import { useEffect, useState } from 'react';
import './App.css';
import Home from './Pages/home';
import PreStories from './Pages/stories';

import SiteNavbar from './components/navbar';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Story from './Pages/story';
import Json from './stories';
import { useTranslation } from 'react-i18next';
function App() {
  let {i18n} = useTranslation();
  useEffect(() => {
    document.documentElement.dir = i18n.dir();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);
  
 

  let imgs = [Json[0].image , Json[1].image  ,Json[2].image , Json[3].image ,Json[4].image , Json[5].image ,Json[6].image , Json[7].image ,Json[8].image]
  let titles = [Json[0].title , Json[1].title  ,Json[2].title , Json[3].title ,Json[4].title , Json[5].title ,Json[6].title , Json[7].title ,Json[8].title]

  let [cards ] = useState([
    {id:0,title:titles[0],img:imgs[0]},
    {id:1,title:titles[1],img:imgs[1]},
    {id:2,title:titles[2],img:imgs[2]},
    {id:3,title:titles[3],img:imgs[3]},
    {id:4,title:titles[4],img:imgs[4]},
    {id:5,title:titles[5],img:imgs[5]},
    {id:6,title:titles[6],img:imgs[6]},
    {id:7,title:titles[7],img:imgs[7]},
    {id:8,title:titles[8],img:imgs[8]},
  ]);

  return (
    <BrowserRouter>
    <div className="App">
       <SiteNavbar/>
       <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='stories' element={<PreStories Cards = {cards}/>}></Route>
        <Route path='story/:id' element={<Story/>}></Route>

       </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
